import { Search } from "@mui/icons-material";
import { InputAdornment, TextField, useTheme } from "@mui/material";

export default function SearchTextFiled({ ...props }) {
    const theme = useTheme()
    return (
        <TextField
            {...props}
            InputProps={
                theme.direction === "rtl" ?
                    {
                        endAdornment: <InputAdornment position="end">
                            <Search />
                        </InputAdornment>,
                    }
                    :
                    {
                        startAdornment: <InputAdornment position="start">
                            <Search />
                        </InputAdornment>,
                    }
            }
        />
    )
}
